import { render, staticRenderFns } from "./HijriDatePicker.vue?vue&type=template&id=1d1b67cb&"
import script from "./HijriDatePicker.vue?vue&type=script&lang=js&"
export * from "./HijriDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports